import { HTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  value: number;
  current: number;
  intlId: string;
};

export const CtrlSex = ({
  value,
  current,
  intlId,
  ...props
}: Props & HTMLAttributes<HTMLInputElement>) => {
  return (
    <div className="form-check form-check-inline ctrl-sex">
      <input
        className="form-check-input"
        type="radio"
        name="sex"
        id={`sex_${value}`}
        value={value}
        defaultChecked={current === value}
        {...props}
      />
      <label className="form-check-label" htmlFor={`sex_${value}`}>
        <FormattedMessage id={intlId} />
      </label>
    </div>
  );
};
